<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Gestão do Grupo {{ dados.nome }}
      </p>
    </div>
    <div class="row">
      <div class="col-2">
        <lista-unidades-select
          class="q-ml-md"
          v-model="unidade"
          :disabled="true"
        ></lista-unidades-select>
      </div>
      <div class="col-md-2 q-ml-sm">
        <q-select
          :options="filtros"
          label="Filtrar"
          dense
          outlined
          v-model="associacao"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
    </div>
    <div>
      <table-adicionar-produto
        :associacao="associacao"
        @atualizar="atualizar"
      />
    </div>
    <div class="row col-12 q-mt-lg">
      <p class="text-h6 text-brand-5 text-weight-bold">Selecionados</p>
    </div>
    <div>
      <table-produtos-selecionados
        :contratoId="contratoId"
        :id="dados.id"
        :atualizar="getSecondTable"
        :showRemove="true"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import TableAdicionarProduto from "../components/TableAdicionarProduto.vue";
import TableProdutosSelecionados from "../components/TableProdutosSelecionados.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: {
    TableAdicionarProduto,
    TableProdutosSelecionados,
    ListaUnidadesSelect,
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const associacao = ref("");
    const dados = JSON.parse(route.params.id);
    const getSecondTable = ref(0);
    const unidade = ref();
    const contratoId = ref("");

    const atualizar = async (value) => {
      getSecondTable.value += value;
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    const listarContratos = async () => {
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("requisicao/listarContratos", {
          per_page: 100,
        });
        let array = response.data.results.data;
        let listaContratosOptions = [];
        array.forEach((contrato) => {
          listaContratosOptions.push({
            label: contrato?.contract?.description,
            vendor_id: contrato?.pivot?.vendor_id,
            contract_id: contrato?.contract_id,
          });
        });
        selecionarContrato(listaContratosOptions);
      } catch (error) {
        console.log(error);
      }
    };

    const selecionarContrato = (array) => {
      let valor = array.filter((contrato) => {
        return contrato.vendor_id == store.state.org.unidadeData.id;
      });
      contratoId.value = valor[0].contract_id;
    };

    onMounted(() => {
      listarContratos();
      getUnidade();
    });

    watch(
      (store.state.org.unidadeData.id,
      () => {
        listarContratos();
      })
    );

    return {
      associacao,
      dados,
      atualizar,
      getSecondTable,
      unidade,
      contratoId,
      filtros: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Produtos Não Associados",
          value: "null",
        },
        {
          label: "Produtos Associados",
          value: "not_null",
        },
      ],
    };
  },
};
</script>
